// @flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel';

import { TransactionChecklistValue } from './TransactionChecklistValue';

import type { TransactionChecklistValueModelType } from './TransactionChecklistValue';

export type TransactionStatusTypeEnum =
    | 'NOT_DELIVERED'
    | 'DELIVERED'
    | 'PARTIALLY_DELIVERED';
export type TransactionStatusModelType = {
    transactedQuantity: number,
    triggerTime: string,
    recievetime: string,
    type: TransactionStatusTypeEnum,
    status?: ?TransactionStatusTypeEnum,
    transactionChecklistValues: Array<TransactionChecklistValueModelType>,
    checklistValues?: ?{ [key: string]: string }
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class TransactionStatus extends ImmutableModel {
    static fromJS(json: TransactionStatusModelType): TransactionStatus {
        const state: Object = Object.assign({}, json);
        state.transactionChecklistValues = Immutable.List(
            state.transactionChecklistValues
        ).map(item => TransactionChecklistValue.fromJS(item));
        state.checklistValues = state.checklistValues
            ? Immutable.Map(state.checklistValues)
            : state.checklistValues;
        return new this(Immutable.Map(state));
    }

    toJS(): TransactionStatusModelType {
        const js: TransactionStatusModelType = {
            transactedQuantity: this.transactedQuantity,
            triggerTime: this.triggerTime,
            recievetime: this.recievetime,
            type: this.type,
            transactionChecklistValues: this.transactionChecklistValues
                .toArray()
                .map(item => item.toJS())
        };

        if (this.status != null) {
            js.status = this.status;
        }

        if (this.checklistValues != null) {
            js.checklistValues = this.checklistValues
                ? this.checklistValues.toObject()
                : this.checklistValues;
        }

        return js;
    }

    get transactedQuantity(): number {
        return this._state.get('transactedQuantity');
    }

    setTransactedQuantity(transactedQuantity: number): this {
        return this.clone(
            this._state.set('transactedQuantity', transactedQuantity)
        );
    }

    get triggerTime(): string {
        return this._state.get('triggerTime');
    }

    setTriggerTime(triggerTime: string): this {
        return this.clone(this._state.set('triggerTime', triggerTime));
    }

    get recievetime(): string {
        return this._state.get('recievetime');
    }

    setRecievetime(recievetime: string): this {
        return this.clone(this._state.set('recievetime', recievetime));
    }

    get type(): TransactionStatusTypeEnum {
        return this._state.get('type');
    }

    setType(type: TransactionStatusTypeEnum): this {
        return this.clone(this._state.set('type', type));
    }

    get status(): ?TransactionStatusTypeEnum {
        return this._state.get('status');
    }

    setStatus(status: ?TransactionStatusTypeEnum): this {
        return this.clone(this._state.set('status', status));
    }

    get transactionChecklistValues(): Immutable.List<TransactionChecklistValue> {
        return this._state.get('transactionChecklistValues');
    }

    setTransactionChecklistValues(
        transactionChecklistValues: Immutable.List<TransactionChecklistValue>
    ): this {
        return this.clone(
            this._state.set(
                'transactionChecklistValues',
                transactionChecklistValues
            )
        );
    }

    get checklistValues(): ?Immutable.Map<string, string> {
        return this._state.get('checklistValues');
    }

    setChecklistValues(checklistValues: ?Immutable.Map<string, string>): this {
        return this.clone(this._state.set('checklistValues', checklistValues));
    }
}
